import axiosServices from "../utils/axios";

interface FetchApiResponce{
    data: any[];
    total: number;
}

// export const fetchPets = async(page: number,
//   pageSize: number, jobId?:string, end_dt?:string, start_dt?:string) =>{
//     const params: any = {
//       page: page + 1,
//       pageSize,
//       start: page * pageSize,
//       limit: pageSize,
//     };
  
//     if (jobId) {
//       params.jobId = jobId;
//     }
//     if (end_dt) {
//       params.end_dt = end_dt;
//     }
//     if (start_dt) {
//       params.start_dt = start_dt;
//     }
//     const response = await axiosServices.get<FetchApiResponce>(`/pets`,{params});
//     return response.data;
// }

export const fetchPets = async (
  page?: number,
  pageSize?: number,
  jobId?: string,
  end_dt?: string,
  start_dt?: string,
  type?: string
) => {
  const params: any = {};

  // Add pagination parameters only if page and pageSize are provided and end_dt/start_dt are not provided
  if (!end_dt && !start_dt && page !== undefined && pageSize !== undefined) {
    params.page = page + 1;
    params.pageSize = pageSize;
    params.start = page * pageSize;
    params.limit = pageSize;
  }

  // Add filter parameters if provided
  if (jobId) {
    params.jobId = jobId;
  }
  if (end_dt) {
    params.end_dt = end_dt;
  }
  if (start_dt) {
    params.start_dt = start_dt;
  }
  if(type){
    params.type = type;
  }

  const response = await axiosServices.get<FetchApiResponce>(`/pets`, { params });
  return response.data;
};

export const deletePetsData = async (id: string) => {
  const response = await axiosServices.delete(`/pets/${id}`);
  return { success: response.data.success, id };
};

export const getPetsDetails = async (id: string) => {
  const response = await axiosServices.get(`/pets/${id}`);
  return response.data.data;
};

export const updatePetsList = async (
  id: string,
  data: {
    [key: string]: any;
  }
) => {
  const response = await axiosServices.put(`/pets/${id}`, data);
  return (response.data.data);
};

const DEFAULT_PETS_EFFICIENCY = "Savings";

export const addPets = async (job_id?: string) => {
  const createdUser = sessionStorage.getItem("UserId");
  const response = await axiosServices.post(`/pets`, {
    job_id,
    created_by: createdUser,
    efficiency: DEFAULT_PETS_EFFICIENCY,
  });
  return response.data.data;
};

export const addPetsDetails = async () => {
  const createdUser = sessionStorage.getItem("UserId");
  const response = await axiosServices.post(`/pets`, {
    created_by: createdUser,
    efficiency: DEFAULT_PETS_EFFICIENCY,
  });
  return response.data.data;
};
